export default __webpack_public_path__ + "static/media/email.be400e31.svg";